<template>
  <div class="row">
    <div class="col-lg-12">
      <!-- Chart Area -->
      <vc-donut has-legend :total="100" :start-angle="0" :sections="sections">Attendance</vc-donut>
    </div>
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <a-table
          :columns="cols"
          :data-source="data">
            <template slot="date"></template>
            <template slot="status" slot-scope="status">
              <a-tag :color="status === 'Absent'? 'red': 'green'">{{ status }}</a-tag>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const cols = [
  {
    title: 'DATE',
    dataIndex: 'date',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: 'STAFF ID',
    dataIndex: 'staff_id',
    scopedSlots: { customRender: 'staff_id' },
  },
  {
    title: 'NAME',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'IN',
    dataIndex: 'in',
    scopedSlots: { customRender: 'in' },
  },
  {
    title: 'OUT',
    dataIndex: 'out',
    scopedSlots: { customRender: 'out' },
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
]

export default {
  name: 'dailyReport',
  data: function() {
    return {
      data: [
        { date: '2022-07-18', staff_id: '9001', name: 'Test Man', in: '9:00 AM', out: '8:00 PM', status: 'Present' },
      ],
      cols,
      sections: [{ label: 'Absent', value: 30 }, { label: 'Present', value: 70 }],
      attendance: { absent: 0, present: 0, totalstaff: 0, data: [] },
    }
  },
  mounted: function() {
    let param = this.$route.params.day
    this.$http.get(`/api/staff/attendance/report/daily?start_date=${param}&end_date=${param}`).then((data) => {
      // console.log(data.data)
      this.attendance = { absent: data.data.data.total_absent, present: data.data.data.total_present, totalstaff: data.data.data.total_staff, data: data.data.data.attendance }
      let labelabsent = `Absent (${this.attendance.absent})`
      let labelpresent = `Present (${this.attendance.present})`
      this.sections = [ { label: labelabsent, value: this.attendance.absent * 100 / this.attendance.totalstaff },
        { label: labelpresent, value: this.attendance.present * 100 / this.attendance.totalstaff } ]
      this.data = this.attendance.data.map(function(e) {
        return { date: e.date != null ? e.date : '-', staff_id: e.system_staff_id, name: e.first_name + ' ' + e.last_name, in: e.start_time != null ? e.start_time : '-', out: e.end_time === null ? '-' : e.end_time, status: e.start_time != null ? 'Present' : 'Absent' }
        // console.log(e)
      })
      // console.log('this.data', this.data)
      // console.log(this.attendance)
    })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    handleBack: function() {
      this.$emit('onBack', 'index')
    },
  },
}
</script>

<style>

</style>
